var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex w-100 justify-content-center align-items-center",
    staticStyle: {
      "height": "78vh"
    }
  }, [_c('div', {
    staticClass: "p-2 p-sm-3"
  }, [_c('div', {
    staticClass: "w-100 text-center"
  }, [_c('h2', {
    staticClass: "mb-1"
  }, [_vm._v("Không thể truy cập vào hệ thống công nợ")]), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v("Bạn không phải thành viên của hệ thống công nợ")]), _c('b-img', {
    staticStyle: {
      "height": "50vh"
    },
    attrs: {
      "fluid": "",
      "src": _vm.imgUrl,
      "alt": "Error page"
    }
  })], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }